//import { SaveDepartamentoPage } from '../../shared/saveDepartamentos';

import { useCheckPermissions } from "@/shared";
import SaveDepartamentoPage from "../../shared/saveDepartamentos/saveDepartamentos";
import { PermissionsEnum } from "@/auth/interfaces";

export interface CreateDepartamentoPageInterface {}

const CreateDepartamentoPage: React.FC<CreateDepartamentoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_departamento)

  return <SaveDepartamentoPage titlePage="Crear departamento" />;
};

export default CreateDepartamentoPage;
